import SmartDeliveryPage from "../admin/SmartDeliveryPage";
import React from "react";


import {
    PageHeader,
    Panel,
} from "../../components/ui/AdminUI";

export default function SmartDeliveryEmployeePage() {
    return (
        <div className="space-y-6">

            <PageHeader
                title="Smart Delivery"
                subtitle="AI-assisted shipment routing and delivery optimization."
            />

            <Panel>
                <SmartDeliveryPage />
            </Panel>

        </div>
    );
}